import { VyPageLayout } from 'apps/app/src/components/new-design/layout/VyPageLayout';
import { withGlobalSearchParams } from 'apps/app/src/components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from 'apps/app/src/components/utility/SuspenseBoundary';
import { useValidatedParams } from 'apps/app/src/hooks/use-validated-params';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import { UnchargedUsageReportContent } from './uncharged-usage-report-components/UnchargedUsageReportContent';

const UnchargedUsageReportPage = () => {
  const { reportId } = useValidatedParams<['reportId']>('reportId');

  return (
    <>
      <Helmet>
        <title>Report</title>
      </Helmet>
      <VyPageLayout
        path={['Reports', <NavLink to="/reports">Reports Lists</NavLink>, 'Uncharged Usage Report']}
        title='Uncharged Usage Report'
      >
        <UnchargedUsageReportContent
          reportId={reportId}
        />
      </VyPageLayout>
    </>
  );
};

const UnchargedUsageReportPageWithSuspenseBoundary = withSuspenseBoundary( withGlobalSearchParams(UnchargedUsageReportPage));
export { UnchargedUsageReportPageWithSuspenseBoundary as UnchargedUsageReportPage };